import { render, staticRenderFns } from "./AccountStake.vue?vue&type=template&id=49124e90&"
import script from "./AccountStake.vue?vue&type=script&lang=js&"
export * from "./AccountStake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports